// src/pages/Workshop.js
import {React, useState} from 'react';
import './Workshop.css'; // Import the new CSS file

import schoolBuilding from '../assets/indutai.jpg';

// --- Lightbox Imports ---
import Lightbox from 'react-18-image-lightbox'; // Import Lightbox component
import 'react-18-image-lightbox/style.css'; // Import Lightbox CSS (Crucial!)


// --- Dynamic Image Import for Special School Gallery ---
const importAll = (r) => {
  // This function maps over all the keys (file paths) returned by require.context
  // and imports each one, returning an array of the imported image modules.
  return r.keys().map(r);
};

// Use require.context to get all image files from the specified directory.
// 1. '../assets/special_school_gallery/' : The directory to search in.
// 2. false : Whether to search subdirectories (we don't need to here).
// 3. /\.jpe?g$|\.png$/ : A regex to match files ending with .jpg, .jpeg, or .png.
const specialSchoolGalleryPhotos = importAll(require.context('../assets/workshop_gallery/', false, /\.jpe?g$|\.png$/));

// You can console.log(specialSchoolGalleryPhotos) here to see the array of image paths
// console.log(specialSchoolGalleryPhotos);

function Workshop() {
  // --- State for Lightbox ---
  const [photoIndex, setPhotoIndex] = useState(0); // Index of the currently viewed photo
  const [isOpen, setIsOpen] = useState(false);     // Whether the lightbox is open

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="workshop-page">

        {/* --- Hero Section --- */}
        <section className="workshop-hero-section">
          <h1 className="workshop-hero-heading">Indutai Dhoble Workshop & Rehabilitation Centre For Mentally Challenged Girls</h1>
          <p className="workshop-hero-subheading">
            Empowering Potential, Fostering Independence
          </p>
        </section>
        
      <div className="container">
        {/* --- Introduction & History Section --- */}
        <section className="workshop-intro-section">
          <h2 className="workshop-section-title">Our Vision & History</h2>
          <p>
            In <b>March 2010</b>, Vishwambhara Shikshan Sanstha (VSS) proudly launched the <b>Indutai Dhoble Workshop & Rehabilitation Centre for Mentally Challenged Girls</b> in Hudkeshwar, Nagpur. This initiative received official sanction from The Handicap Welfare Commissioner, Pune, MS Govt., marking a significant step in our commitment to vocational training for adult mentally challenged girls.
          </p>
          <p className="workshop-highlight-text">
            At the Indutai Dhoble workshop and rehabilitation center, we firmly believe in the power of opportunity and the strength of community. Our dedicated workshop offers intellectually disabled girls a <b>safe and supportive environment</b> where they can explore their unique talents and develop essential life skills. Through practical, hands-on experience in various trades, we empower these young women to unlock their full potential and express their creativity.
          </p>
        </section>

        {/* Optional Image Section 1 */}
        <div className="school-image-wrapper">
          <img
            src={schoolBuilding}
            alt="Special School Building"
            className="school-image"
          />
        </div>

        {/* --- Diverse Trade Opportunities Section --- */}
        <section className="trade-opportunities-section">
          <h2 className="workshop-section-title">Diverse Trade Opportunities</h2>
          <p className="trade-intro">Our workshop offers a range of engaging activities designed to cater to diverse interests and skill levels, ensuring every participant finds a path to growth and fulfillment:</p>
          <div className="trade-cards-grid">
            <div className="trade-card">
              <h3>1. Crafts</h3>
              <p>Girls immerse themselves in the world of <b>crafts</b>, learning techniques to create beautiful, handmade items. This not only nurtures their artistic abilities but also instills a profound sense of pride in their unique creations.</p>
            </div>
            <div className="trade-card">
              <h3>2. Stitching</h3>
              <p>Through our <b>stitching program</b>, participants acquire valuable sewing skills, progressing from basic techniques to more complex projects. This trade significantly enhances their dexterity and opens doors to future vocational opportunities.</p>
            </div>
            <div className="trade-card">
              <h3>3. Packaging</h3>
              <p>In our <b>packaging</b> area, girls master the essentials of professionally packaging various products. This practical skill teaches the importance of presentation and meticulous attention to detail in a business context.</p>
            </div>
            <div className="trade-card">
              <h3>4. File Making</h3>
              <p>Our <b>file-making</b> sessions cultivate organizational skills and creativity, as participants meticulously craft personalized files and organizers. This activity fosters a strong sense of accomplishment while preparing them for potential future roles in administration or office support.</p>
            </div>
          </div>
        </section>

        {/* --- Special Projects Section --- */}
        <section className="special-projects-section">
          <h2 className="workshop-section-title">Special Projects</h2>
          <p className="special-projects-intro">Beyond our core trades, we offer unique and engaging projects that encourage creative expression and foster deeper community engagement:</p>
          <div className="special-projects-grid">
            <div className="project-card">
              <h3>Diya Making</h3>
              <p>Girls engage in the traditional art of <b>diya making</b>, meticulously creating beautiful, hand-painted lamps that can illuminate any space. This project thoughtfully connects them to their cultural heritage while profoundly fostering their creativity.</p>
            </div>
            <div className="project-card">
              <h3>Wax Candle Making</h3>
              <p>Participants explore the intricate art of <b>candle making</b>, learning to craft beautiful, often scented, candles. This hands-on activity not only refines their motor skills but also provides the immense joy of creating tangible products they can proudly share with family and friends.</p>
            </div>
          </div>
        </section>

        {/* --- Building Confidence and Skills Section --- */}
        <section className="confidence-skills-section">
          <h2 className="workshop-section-title">Building Confidence & Skills</h2>
          <p>
            Our workshop is far more than just a place to learn trades; it’s a vibrant community where intellectually disabled girls can <b>build confidence, forge lasting friendships, and truly discover their inherent strengths</b>. Through our nurturing and supportive environment, they acquire invaluable life skills, ranging from teamwork and effective communication to critical problem-solving and vital resilience.
          </p>
          <p>
            At <b>VISHWAMBHARA SHIKSHAN SANSTHA</b>, we are profoundly committed to fostering an inclusive space where every girl has the opportunity to thrive. By empowering these young women with essential skills and meaningful opportunities, we are actively helping them pave the way for a brighter, more independent future.
          </p>
          <p className="workshop-cta">
            Join us in celebrating the creativity and immense potential of intellectually disabled girls! Together, we can create a more inclusive society where everyone, regardless of their challenges, has the chance to truly shine.
          </p>
        </section>
        
                {/* --- Gallery Section (with Lightbox) --- */}
                <section className="school-gallery-section">
                  <h2 className="school-section-title">Our Moments of Joy & Learning</h2>
                  <div className="gallery-grid">
                    {specialSchoolGalleryPhotos.map((photoUrl, index) => (
                      <div
                        className="gallery-item"
                        key={index}
                        onClick={() => openLightbox(index)} // Open lightbox on click
                        style={{ cursor: 'pointer' }} // Visual cue for clickable items
                      >
                        {/* Ensure alt text is meaningful, or add it to the image array if available */}
                        <img src={photoUrl} alt={`Special School Moment ${index + 1}`} className="gallery-image" loading="lazy" />
                        <div className="gallery-overlay">
                          {/* You could add a caption here if your image data included one */}
                          <span className="gallery-caption">View Photo</span>
                        </div>
                      </div>
                    ))}
                  </div>
        
                  {/* --- Lightbox Component --- */}
                  {isOpen && (
                    <Lightbox
                      mainSrc={specialSchoolGalleryPhotos[photoIndex]}
                      nextSrc={specialSchoolGalleryPhotos[(photoIndex + 1) % specialSchoolGalleryPhotos.length]}
                      prevSrc={specialSchoolGalleryPhotos[(photoIndex + specialSchoolGalleryPhotos.length - 1) % specialSchoolGalleryPhotos.length]}
                      onCloseRequest={() => setIsOpen(false)}
                      onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + specialSchoolGalleryPhotos.length - 1) % specialSchoolGalleryPhotos.length)
                      }
                      onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % specialSchoolGalleryPhotos.length)
                      }
                      imageTitle={`Photo ${photoIndex + 1} of ${specialSchoolGalleryPhotos.length}`}
                      // Add other Lightbox props as needed, e.g., imageCaption, enableZoom
                    />
                  )}
                </section>

      </div> {/* End .container */}
    </div>
  );
}

export default Workshop;